export const MAKO_CLI_CALLBACK_URL_KEY = "makoCliCallbackUrl";
export const MAKO_CLI_NONCE_KEY = "makoCliNonce";
export const MAKO_CLI_FLOW_KEY = "makoCliFlow";

const SESSION_ID_PATH_REGEX = /^\/callback\/([0-9a-f]{32})$/i;
const NONCE_REGEX = /^[0-9a-f]{32}$/i;

type CliCallbackValidationFailure = {
  ok: false;
  error: string;
};

type CliCallbackValidationSuccess = {
  ok: true;
  normalized: string;
  sessionId: string;
};

type CliNonceValidation =
  | { ok: true }
  | {
      ok: false;
      error: string;
    };

export function validateCliCallbackUrl(
  callbackUrl?: string | null
): CliCallbackValidationFailure | CliCallbackValidationSuccess {
  if (!callbackUrl || typeof callbackUrl !== "string") {
    return { ok: false, error: "Missing callback_url." };
  }

  let url: URL;
  try {
    url = new URL(callbackUrl);
  } catch {
    return { ok: false, error: "Invalid callback_url." };
  }

  if (url.protocol !== "http:") {
    return { ok: false, error: "callback_url must use http." };
  }
  if (url.hostname !== "127.0.0.1") {
    return { ok: false, error: "callback_url must use 127.0.0.1." };
  }
  if (!url.port || !/^[0-9]+$/.test(url.port)) {
    return { ok: false, error: "callback_url must include a numeric port." };
  }
  const port = Number(url.port);
  if (port < 1 || port > 65535) {
    return { ok: false, error: "callback_url port is out of range." };
  }
  if (url.username || url.password) {
    return { ok: false, error: "callback_url must not include credentials." };
  }
  if (url.search) {
    return {
      ok: false,
      error: "callback_url must not include query parameters.",
    };
  }
  if (url.hash) {
    return { ok: false, error: "callback_url must not include fragments." };
  }

  const match = url.pathname.match(SESSION_ID_PATH_REGEX);
  if (!match) {
    return {
      ok: false,
      error: "callback_url path must match /callback/<session_id>.",
    };
  }

  return { ok: true, normalized: url.toString(), sessionId: match[1] };
}

export function validateCliNonce(nonce?: string | null): CliNonceValidation {
  if (!nonce || typeof nonce !== "string") {
    return { ok: false, error: "Missing nonce." };
  }
  if (!NONCE_REGEX.test(nonce)) {
    return { ok: false, error: "Invalid nonce." };
  }
  return { ok: true };
}
